import React from "react";
import PropTypes from "prop-types";
import Button from '@material-ui/core/Button';
import i18n from "../../i18n"

const Style = {
    textTransform: 'none',
    fontFamily: 'montserratRegular',
    boxShadow: 'none'
};

const PrimaryButton = ({className, style, onClick, disabled, formId, type, label, variant}) => {

	return <Button
        className={`${className} pointer`}
        style={{...Style, ...style}}
        color="secondary"
        variant={variant}
        onClick={onClick}
        disabled={disabled}
        form={formId}
        type={type}
    >
       {i18n.t(label)}
    </Button>
}

PrimaryButton.defaultProps = {
    style:{},
    label:"Submit",
    disabled: false,
    formId: "",
    variant: "outlined"
};

PrimaryButton.propTypes = {
    label:PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.node
    ]),
    style:PropTypes.object,
    onClick:PropTypes.func,
    formId: PropTypes.string,
    type: PropTypes.string,
    disabled: PropTypes.bool, 
}

export default PrimaryButton;



// WEBPACK FOOTER //
// ./src/components/buttons/PrimaryButton.js